module.exports = __webpack_public_path__ + "img/grup-team-roster-selected.d1fd45f1.svg";